import type { CustomerRevenueReportItem } from '@vy/types';
import type { FilterLineType } from '../../../../components/new-design/vyTableFilter';
import {
  applyReportFilters,
  type FilterPredicateMap,
} from '../../reports-components/apply-report-filters';
import {
  matchesLabelSelection,
  matchesStringSelection,
} from '../../reports-components/shared-filter-fields';
import { CUSTOMER_REVENUE_FILTER_FIELD_IDS } from './customer-revenue-filter-field-ids';

const PREDICATES: FilterPredicateMap<CustomerRevenueReportItem> = {
  [CUSTOMER_REVENUE_FILTER_FIELD_IDS.CustomerId]: (item, value) =>
    matchesStringSelection(item.customer.id, value),

  [CUSTOMER_REVENUE_FILTER_FIELD_IDS.Currency]: (item, value) =>
    matchesStringSelection(item.customer.currency, value),

  [CUSTOMER_REVENUE_FILTER_FIELD_IDS.Country]: (item, value) =>
    matchesStringSelection(item.customer.country ?? null, value),

  [CUSTOMER_REVENUE_FILTER_FIELD_IDS.State]: (item, value) =>
    matchesStringSelection(item.customer.state ?? null, value),

  [CUSTOMER_REVENUE_FILTER_FIELD_IDS.Product]: (item, value) =>
    matchesStringSelection(item.productId ?? null, value),

  [CUSTOMER_REVENUE_FILTER_FIELD_IDS.ContractStatus]: (item, value) =>
    matchesStringSelection(item.contract?.status ?? null, value),

  [CUSTOMER_REVENUE_FILTER_FIELD_IDS.Labels]: (item, value) =>
    matchesLabelSelection(
      (item.customer.labels ?? []).map((label) => label.id),
      value,
    ),

  [CUSTOMER_REVENUE_FILTER_FIELD_IDS.Plan]: (item, value) =>
    matchesStringSelection(item.planName ?? null, value),
};

export function applyCustomerRevenueFilters(
  reportItems: CustomerRevenueReportItem[],
  filters: FilterLineType[],
): CustomerRevenueReportItem[] {
  return applyReportFilters(reportItems, filters, PREDICATES);
}
